import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import Vuln from './VulnPreview';
import { AddWrapper, Wrapper, Label, VulnsWrapper, dropdownStyle } from './styled';

import { useDispatch, useSelector } from 'react-redux';
import { selectVulnDetail } from 'store/Manage/selectors';
import { getAvailableVulns } from 'store/Credentials/actions';
import { selectAvailableVulns, selectFetchingVulns } from 'store/Credentials/selectors';
import useTheme from 'Hooks/UseTheme';

const LinkedVulns = ({ vulns, setLinkedVuln }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const subtitle = intl.formatMessage({
    id: 'credentials.modalCreateEdit.linkedVulns'
  });
  const currentVuln = useSelector(selectVulnDetail);
  const availableVulns = useSelector(selectAvailableVulns);
  const [vulnsOptions, setVulns] = useState(availableVulns);
  const [selectedOption, setSelectedOption] = useState('');
  const options = vulnsOptions.map((u) => ({ value: u.value, label: u.value.name }));
  const [showOptions, setShowOptions] = useState(false);
  const { themeStyles } = useTheme();
  const isLoading = useSelector(selectFetchingVulns);

  const handleInputChange = useCallback((typedOption) => {
    if (typedOption.length > 2) {
      dispatch(getAvailableVulns(typedOption, setVulns));
      setShowOptions(true);
    } else setShowOptions(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (v) => {
    const vulnNotAdded = vulns?.every((vuln) => vuln.id !== v.value.id);
    if (vulnNotAdded) {
      setSelectedOption(v.value);
      setLinkedVuln([...vulns, v.value]);
    }
  };

  return (
    <Wrapper>
      <AddWrapper>
        <Label children={ subtitle } />
        <Select
          value={ selectedOption }
          options={ showOptions ? options.filter((r) => r.label !== selectedOption) : [] }
          onChange={ handleChange }
          onInputChange = { handleInputChange }
          controlShouldRenderValue={ false }
          styles={ dropdownStyle(themeStyles) }
          placeholder="Search vulns"
          isLoading={ isLoading }
        />
      </AddWrapper>
      <VulnList
        vulns={ vulns || [] }
        deleteVuln={ (id) => setLinkedVuln(vulns.filter((v) => v.id !== id)) }
        currentVuln={ currentVuln }
      />
    </Wrapper>
  );
};

export default LinkedVulns;

const VulnList = ({ vulns, deleteVuln }) => {
  const sortedVulns = (vulns ?? [])?.sort((v1, v2) => {
    if (v1.allowed && !v2.allowed) return -1;
    if (!v1.allowed && v2.allowed) return 1;
    return v1.id - v2.id;
  });

  const isOdd = (n) => n % 2 !== 0;
  return (
    <VulnsWrapper showGradient={ vulns?.length < 3 }>
      {sortedVulns?.map((v, i) => (
        <Vuln
          isOdd={ isOdd(i) }
          isEditingTask
          key={ v.id }
          vuln={ v }
          deleteVuln={ () => deleteVuln(v.id) }
          bgColor="#ffffff"
        />
      ))}
    </VulnsWrapper>
  );
};
